import { render } from "./maintain.vue?vue&type=template&id=0bfdbe6f"
import script from "./maintain.vue?vue&type=script&lang=js"
export * from "./maintain.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__